import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const KeyDelays = ({ delays }) => {
    const hasDelays = Array.isArray(delays) && delays.length > 0;

    return (
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 mb-6">
            <h3 className="font-bold text-lg text-gray-900 mb-4">Key Delays</h3>

            <div className="space-y-4">
                {!hasDelays ? (
                    <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
                        <CheckCircle2 className="w-12 h-12 text-emerald-500 mb-3" strokeWidth={1.5} />
                        <p className="text-gray-600 font-medium">No key delays this period</p>
                        <p className="text-gray-500 text-sm mt-1">Tasks are on track — no significant delays to report.</p>
                    </div>
                ) : (
                delays.map((delay) => (
                    <div key={delay.id} className="border-b border-gray-100 pb-4 last:border-0 last:pb-0">
                        <div className="flex justify-between items-start mb-1">
                            <h4 className="text-gray-800 font-semibold">{delay.title}</h4>
                            <span className="text-red-500 font-bold text-lg">{delay.days}d</span>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:gap-12 text-sm text-gray-500">
                            <p><span className="font-medium text-gray-700">Reason:</span> {delay.reason}</p>
                            <p><span className="font-medium text-gray-700">Responsible:</span> {delay.responsible}</p>
                        </div>
                    </div>
                ))
                )
                }
            </div>
        </div>
    );
};

export default KeyDelays;
